<template>
    <div class="button" @mousedown="mousedownEvt" @mouseup="mouseupEvt" @mouseleave="mouseupEvt">
        <slot />
    </div>
</template>


<script>
export default {
    emits:['mousedown','mouseup'],
    data(){
        return{

        }
    },
    methods:{
        mousedownEvt(){
            this.$emit('mousedown')
        },
        mouseupEvt(){
            this.$emit('mouseup')
        }
    },
}
</script>

<style scoped>
.button{
    width: 100%; 
    height: 40px; 
    background:#8a66c7;
    color: white;
    justify-content: center;
    align-items: center;
    display: flex;
    align-self: center;
    justify-self: center;
    cursor: pointer;
}

.button:hover, .button.active{
    background: #7053A3;
}



</style>